import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-acs-codes-modal',
  templateUrl: './select-acs-codes-modal.component.html',
  styleUrls: ['./select-acs-codes-modal.component.scss']
})
export class SelectAcsCodesModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
